<template>
    <div class='eleDataResult-wrap'>
        <p class="title">{{obj.title}}</p>
        <div class="echarts">
            <div :id="id" class="gauge"></div>
        </div>
        <div class="echarts-title">
            <p class="echarts-txt">
                <span class="circle-first icon"></span>
                <span class="circle-txt">0~59不及格</span>
            </p>
            <p class="echarts-txt">
                <span class="circle-second icon"></span>
                <span class="circle-txt">60~100及格</span>
            </p>
        </div>
        <div class="proposal">
            <p class="proposal-txt">据统计:某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某</p>
            <p class="proposal-ts">温馨提示</p>
        </div>
    </div>
</template>

<script>
import uuidv1 from "uuid/v1";
import echarts from "echarts";
export default {
    name:"EleDataResult",
    props:{
        obj:{
            type:Object,
            default:()=>{}
        }
    },
    data() {
        return {
            id:uuidv1()
        };
    },
    created() {
        this.$nextTick(()=>{
            this.drawPie();
        })
    },
    mounted() {
        
    },
    methods: {
        drawPie() {
            this.charts = echarts.init(document.getElementById(this.id));
            this.charts.setOption({
                backgroundColor: "#fff", //rgba设置透明度0.1
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                series: [{
                    "name": '小圆形',
                    "type": 'pie',
                    "hoverAnimation": false,
                    "legendHoverLink": false,
                    "radius": ['15%', '0%'],
                    center:["50%","71%"],
                    "z": 3,
                    label: {
                        position: 'center',
                        color:"#fff",
                        fontWeight:"bold"
                    },
                    "labelLine": {
                        "normal": {
                            "show": false
                        }
                    },
                    "data": [{
                        value:100,
                        name:"86",
                        itemStyle: {
                            normal: {
                                color: "#0097EE"
                            },
                            emphasis: {
                                color: "#0097EE"
                            }
                        }
                    }]
                },{
                    radius: "100%",
                    min: 0,
                    max: 100,
                    center:["50%","70%"],
                    startAngle: 180, //开始角度 左侧角度
                    endAngle: 0, //结束角度 右侧
                    name: "业务指标",
                    type: "gauge",
                    detail: { 
                        formatter:(params)=>{
                            return params >=60 ? '及格':'不及格';
                        },
                        fontSize:18,
                        fontWeight:"bold"
                    },
                    axisLine: {
                        // 坐标轴线
                        lineStyle: {
                            width: 6,
                            // 属性lineStyle控制线条样式
                            color: [
                                [0.6, "#0097EE"],
                                [1, "#CF3B13"]
                            ]
                        }
                    },
                    //仪表盘小刻度样式
                    axisTick: {
                        show: false
                    },
                    //仪表盘大刻度样式
                    splitLine: {
                        length: 12,
                        lineStyle: {
                            color: "auto"
                        }
                    },
                    pointer: {
                        width: 6,
                        length: "80%",
                        itemStyle: {
                            color: [
                                [0.6, "#0097EE"],
                                [1, "#CF3B13"]
                            ]
                        }
                    },
                    title: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    data: [{ value: 0, name: "完成率" }]
                }]
            });
        }
    }
}
</script>

<style lang='less' scoped>
    .eleDataResult-wrap{
        width: 100%;height: 100%;display: flex;flex-flow: column;position: relative;
        .title{
            font-weight: bold;color: #2e3842;height: 30px;line-height: 30px;background: #f0f3f4;padding: 0px 10px;box-sizing: border-box;
        }
        .echarts{
            flex: 1;width: 100%;padding:5px;box-sizing:border-box;
            .gauge{
                width: 100%;height: 100%;
            }
        }
        .echarts-title{
            position: absolute;left: 0;top: 40px;display: flex;justify-content: center;width:100%;
            .echarts-txt{
                display: flex;margin-right:20px;align-items: center;
                .icon{
                    width: 12px;height: 12px;border-radius: 2px;display: inline-block;background: #0097EE;margin-right: 5px;
                }
                .circle-second{
                    background: #CF3B13;
                }
                .circle-txt{
                    color: #636363;font-size: 12px;
                }
            }
        }
        .proposal{
            width: 100%;height: 100px;padding: 0 10px;box-sizing: border-box;position: relative;display:flex;margin-bottom:5px;
            .proposal-txt{
                flex:1;margin-left: 20px;background: #f1f2f4;border-radius: 4px;overflow: hidden;white-space: break-spaces;padding: 0 10px 0 25px;box-sizing: border-box;
                text-indent:2em;line-height: 24px;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;
            }
            .proposal-ts{
                position: absolute;left: 10px;top: 12px;background: #06b39c;color: #fff;writing-mode: tb;padding: 10px;border-radius: 4px;overflow: hidden;
            }
        }
    }
</style>